import SEO from '../../components/base/SEO';
import SchemaOrg from '../../components/base/SchemaOrg';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import StoryHeroSection from './components/StoryHeroSection';
import BeginningSection from './components/BeginningSection';
import CommunityValuesSection from './components/CommunityValuesSection';
import VisionSection from './components/VisionSection';

export default function AboutPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const aboutPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '우리의 이야기',
    description: '2016년부터 시작된 Daygreen의 여정. 봉제 기술 교육을 통한 자립 지원, 업사이클링 패션, 그리고 지속가능한 공동체를 만들어가는 우리의 이야기',
    url: `${siteUrl}/about`,
    inLanguage: 'ko-KR',
    mainEntity: {
      '@type': 'Organization',
      name: 'Daygreen',
      foundingDate: '2016',
      description: '봉제 기술 교육과 업사이클링을 통해 지속가능한 패션 산업을 만들어가는 사회적기업',
    },
  };

  return (
    <>
      <SEO
        title="우리의 이야기 - Daygreen | 사회적기업의 시작과 비전"
        description="2016년부터 시작된 Daygreen의 여정. 봉제 기술 교육을 통한 자립 지원, 업사이클링 패션, 그리고 지속가능한 공동체를 만들어가는 우리의 이야기를 소개합니다."
        keywords="Daygreen 스토리, 사회적기업 비전, 봉제 기술 교육, 자립 지원, 업사이클링, 지속가능한 공동체, 사회적 가치"
        canonical="/about"
        ogType="article"
      />
      <SchemaOrg schema={aboutPageSchema} />
      <div className="min-h-screen">
        <Navbar />
        <StoryHeroSection />
        <BeginningSection />
        <CommunityValuesSection />
        <VisionSection />
        <Footer />
      </div>
    </>
  );
}